import { createContext } from "react";
export var SearchResultsContext = createContext({
    loading: false,
    filterOptionsLoading: false,
    error: undefined,
    searchData: null,
});
